import { render } from "./ProjectSourcesImages.vue?vue&type=template&id=883c6c68&lang=true"
import script from "./ProjectSourcesImages.vue?vue&type=script&lang=js"
export * from "./ProjectSourcesImages.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__